import { useQuery } from '@tanstack/react-query';
import { useIsExtraModule } from '../useIsExtraModule';
import { contentListQueries } from 'src/modules/contentList/queries';
export function useModules(options) {
    const isExtraModule = useIsExtraModule();
    return useQuery({
        ...options,
        ...contentListQueries.getModules({ extra: isExtraModule })
    });
}
